import { quat, ReadonlyQuat, ReadonlyVec3, vec3, vec4 } from "gl-matrix";

export class Pose {
  _p?: vec3;
  _q: vec4;

  constructor(hasPos: boolean) {
    if (hasPos) {
      this._p = vec3.create();
    }
    this._q = quat.create();
  }

  get pos(): vec3 | undefined {
    return this._p;
  }

  set pos(p: ReadonlyVec3 | undefined) {
    if (!this._p) this._p = vec3.create();
    if (p) vec3.copy(this._p, p);
  }

  get quat(): quat {
    return this._q;
  }

  set quat(q: ReadonlyQuat) {
    quat.copy(this._q, q);
  }

  get data(): number[] {
    return this._p ? [...this._p, ...this._q] : [...this._q];
  }
}
